import React from "react";
import Routes from "./Routes";
import { AuthProvider } from './utils/AuthContext.jsx';
import { ChatThemeProvider } from './utils/useChatTheme.jsx';
import { Analytics } from "@vercel/analytics/react"
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <ChatThemeProvider>
          <Routes />
          <Analytics />
        </ChatThemeProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
